import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '3900e609-f6cc-445b-879b-b65e3470167d',
	[AppLanguageCodes.SK]: '3900e609-f6cc-445b-879b-b65e3470167d',
	[AppLanguageCodes.DE]: '3900e609-f6cc-445b-879b-b65e3470167d',
}


export const Infobox = () => {

	return (
		<MdxDiv className='info-box' articleIds={articleIds}>
		</MdxDiv>
	);
};